export const AWS_CONTACT_US_LINK = "https://aws.amazon.com/contact-us";

export enum MimeType {
    OCTET_STREAM = "application/octet-stream",
}

export const UNKNOWN_STATUS_CODE = 0;

export enum LandingPageState {
    BANNER_ONLY,
    FULL_PAGE,
}

export enum BrowserType {
    APPSTREAM = "AppStream",
}

export const ConfigElements = {
    ENV_INFO: "env-info",
    CUSTOMER_CONFIG: "customer-config",
    FEATURES: "features",
    SETTINGS: "settings",
};

export enum ColorTheme {
    LIGHT = "Light",
    DARK = "Dark",
}

export const ONE_YEAR_IN_MS = 1000 * 60 * 60 * 24 * 365;
